import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <div >
            <nav className="navbar navbar-expand-lg navbar-light" >
                <div className="container-fluid">
                    <Link className="navbar-brand ps-md-5 ms-md-5" to="/">Raj <span style={{ color: '#198754' }}>Dev</span></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav pe-md-4 ms-auto">
                            <Link className="nav-link pe-md-4 active" aria-current="page" to="/home">Home</Link>
                            <a href="#project" className="nav-link pe-md-4">Project</a>
                            <a href="#about" className="nav-link pe-md-4">About</a>
                            <a href="#blog" className="nav-link pe-md-4">Blog</a>
                            <a href="#contact" className="nav-link pe-md-4">Contact</a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;